module.exports = __webpack_public_path__ + "static/project-16g-88052ae5c1bf672a780a4a118dc18290.png";